import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as cn from 'classnames';
import { Spacer, Typography } from '@emburse/ui-core';
import { AccountCircleIcon, Icon } from '@emburse/ui-essentials';
export const AccountIconWithEmail = ({ className, email }) => (_jsxs("div", Object.assign({ className: cn('view-email', 'flex', className) }, { children: [_jsx(Icon, { iconUrl: AccountCircleIcon }), _jsx(Spacer, { size: 10, direction: "horizontal" }), _jsx(Typography, Object.assign({ variant: "body1" }, { children: email }))] })));
